import React, { FC } from 'react';
import classNames from 'classnames';
import { Link } from '../Link';
import { Image } from '../Image';
import PlayerIcon from '../PlayerIcon';
import ExposureContainer from '../ExposureContainer';
import { useNewsItemModuleViewParams, useNewsItemModuleClickParams } from './hooks/useLxParams';
import type { SizeType } from '../../types/index';
import { NewsCenterItem } from '../../api/newsApi';
import styles from './NewsItem.module.scss';
import { useModuleClick } from '../Layout/lxContext';

import NewsTag from '../NewsTag';
import { useImage } from '../../hooks/useImage';
import useNewsHref from './hooks/useNewsHref';

interface Props {
  newsItemData: NewsCenterItem;
  newsSize?: SizeType;
  showAbstract?: boolean;
  showTag?: boolean;
  // showOrigin?: boolean;
  /* 标识新闻模块所处的位置，用于埋点 */
  position?: number;
  /* 标识新闻的来源，用于埋点 */
  source?: string;
}

const NewsItemCenter: FC<Props> = (props) => {
  const {
    newsItemData,
    newsSize,
    showAbstract = true,
    showTag = true,
    // showOrigin = true,
    position,
    source,
  } = props;
  const boxBaseClass = 'flex w-full';

  const moduleViewParam = useNewsItemModuleViewParams({
    position,
    newsNo: newsItemData.newsNo,
    newsTitle: newsItemData.newsTitle,
  });
  const moduleClickParam = useNewsItemModuleClickParams({
    position,
    newsNo: newsItemData.newsNo,
    newsTitle: newsItemData.newsTitle,
  });

  const moduleClick = useModuleClick();

  const handleClick = () => {
    moduleClick?.(moduleClickParam);
  };

  const suffix = useImage(newsItemData?.newsImg, 416);

  const { href, handleClickImg } = useNewsHref({
    newsNo: newsItemData.newsNo,
    newsCardType: newsItemData.newsCardType,
    source,
  });

  return (
    <Link href={href} legacyBehavior prefetch={false}>
      <a target="_blank" className={classNames('relative block lg:mb-8', styles['news-item-center-wrap'])}>
        <ExposureContainer
          className={classNames(styles['news-item-box'], boxBaseClass, 'flex cursor-pointer')}
          moduleViewParam={moduleViewParam}
          onClick={handleClick}
        >
          <>
            <div className="flex flex-1 pr-3 lg:h-[9.75rem] lg:items-center lg:pr-10">
              <div className="flex flex-col lg:h-auto lg:justify-between ">
                <h2 className="mb-[4px] overflow-hidden break-all text-sm font-medium leading-1.375r text-black line-clamp-2 lg:mb-3 lg:text-xl lg:leading-7 lg:hover:underline">
                  {newsItemData.newsTitle}
                </h2>
                {showAbstract && (
                  <div className="mb-[12px] mt-0 break-all font-[PingFangSC-Regular] text-xs leading-5 text-black opacity-65 line-clamp-1 lg:mb-5 lg:mt-0 lg:text-base lg:leading-6 lg:line-clamp-2">
                    {newsItemData.newsAbstract}
                  </div>
                )}
                <div className="flex items-center text-mini lg:text-sm">
                  {/* 新闻标签 */}
                  {showTag && (
                    <span className="mr-2.5 flex-shrink-0 lg:mr-5">
                      <NewsTag tagVal={newsItemData.newsTypeId} tagName={newsItemData.newsType} />
                    </span>
                  )}
                  {/* <NewsTag tagVal="gongzuo" /> */}
                  <span className="mr-2.5 flex-shrink-0 text-black-35 lg:mr-5">{newsItemData.newsDate}</span>
                  {/* {showOrigin && (
                    <span className="text-black-35 line-clamp-1">
                      {newsItemData.newsOrigin ? newsItemData.newsOrigin : '美团'}
                    </span>
                  )} */}
                </div>
              </div>
            </div>
            {newsItemData?.newsImg ? (
              <div
                onClick={handleClickImg}
                className="relative h-[98px] w-8.125r translate-y-0 overflow-hidden rounded-lg lg:h-[9.75rem] lg:w-[13rem] lg:rounded-2xl"
              >
                <div className={classNames(styles['img-box'], 'h-full w-full')}>
                  <Image
                    src={`${newsItemData.newsImg}${suffix}`}
                    objectFit="cover"
                    layout="responsive"
                    width={400}
                    height={300}
                  />
                  {/* VIDEO:视频 IMAGE_TEXT图文 */}
                </div>
                {newsItemData.newsCardType === 'VIDEO' && <PlayerIcon size={newsSize} />}
              </div>
            ) : null}
          </>
        </ExposureContainer>
      </a>
    </Link>
  );
};

NewsItemCenter.displayName = 'NewsItemCenter';
NewsItemCenter.defaultProps = {
  newsItemData: {
    newsFocusImg: '',
    newsImg: '',
    newsNo: '',
    newsTypeId: '',
    newsTitle: '',
    newsAbstract: '',
    newsType: '',
    newsDate: '',
    newsOrigin: '',
  },
};
export default NewsItemCenter;
